import {
  messageId,
  PropertyMeta,
  ValueObjectMetaString,
} from "@pscsrvlab/psc-react-components";
import { z } from "zod";
const minimalSchema = z.string().max(10000);
const savedMinimalSchema = z.string().max(10000);
const schema = z.string().max(10000);
const savedSchema = z.string().max(10000);
const jsonSchema = z.string();
/**
 * 審査会アジェンダ(値オブジェクト)のメタデータ。
 *
 *  */
export const reviewConferenceAgendaMeta = new ValueObjectMetaString(
  "ReviewConferenceAgenda",
  "\u5BE9\u67FB\u4F1A\u30A2\u30B8\u30A7\u30F3\u30C0",
  messageId("lbl.\u5BE9\u67FB\u4F1A\u30A2\u30B8\u30A7\u30F3\u30C0"),
  minimalSchema,
  schema,
  jsonSchema,
  undefined,
  undefined
);
